import { render, staticRenderFns } from "./characterDetail.vue?vue&type=template&id=889481be&scoped=true&"
import script from "./characterDetail.vue?vue&type=script&lang=js&"
export * from "./characterDetail.vue?vue&type=script&lang=js&"
import style0 from "./characterDetail.vue?vue&type=style&index=0&id=889481be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "889481be",
  null
  
)

export default component.exports